const getters = {
  token: state => state.user.token,
  headimgurl: state => state.user.headimgurl,
  nickname: state => state.user.nickname,
  notice:state=>state.user.notice
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js